import '../styles/CrawlsOpener.css';
import React from 'react';

function RuleMark() {
  return (
    <span className="cop-mark" aria-hidden="true">
      <svg viewBox="0 0 40 10" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M1 6.2 C8 5.2 13 7.4 19 5.6 S31 3.8 39 5.1"
          stroke="currentColor"
          strokeWidth="1.1"
          strokeLinecap="round"
        />
        <path
          d="M2 8.6 C10 7.8 15 9.2 20 8 S30 6.9 38 7.8"
          stroke="currentColor"
          strokeWidth="0.8"
          strokeLinecap="round"
          opacity="0.45"
        />
        <circle cx="20" cy="5.5" r="1.4" fill="currentColor" />
      </svg>
    </span>
  );
}

function CrawlsOpener() {
  return (
    <section className="cop-root" aria-labelledby="cop-heading">
      <div className="cop-inner" data-content-rail="reading">
        <div className="cop-opener">
          <RuleMark />
          <p className="cop-label">Crawl history</p>
        </div>

        <h1 className="cop-heading" id="cop-heading">Your crawls</h1>

        <p className="cop-statement">
          Each crawl lists its starting target, its current status, how far the
          crawl has progressed, and the number of emails found so far. Pick a
          crawl to follow its progress and review the leads it extracted.
        </p>

        <div className="cop-actions">
          <a className="cop-cta" href="/new-crawl">
            <span className="cop-cta-label">Start a new crawl</span>
            <span className="cop-cta-arrow" aria-hidden="true">
              <svg viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M3 11h15M13 5.5 18.5 11 13 16.5"
                  stroke="currentColor"
                  strokeWidth="1.4"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </span>
          </a>
          <a className="cop-link" href="/leads">
            <span className="cop-link-icon" aria-hidden="true">
              <svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="1" y="2.8" width="16" height="12.4" rx="1.8" stroke="currentColor" strokeWidth="1.1" />
                <path
                  d="M1.8 4 9 9.6 16.2 4"
                  stroke="currentColor"
                  strokeWidth="1.1"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </span>
            Open Leads
          </a>
        </div>
      </div>
    </section>
  );
}

export default CrawlsOpener;